// extracted by mini-css-extract-plugin
export default {"breadcrumbSeperator":"SearchBreadCrumb-module__breadcrumbSeperator___3Sloq","breadcrumbs":"SearchBreadCrumb-module__breadcrumbs___3aAc6"};